import React from 'react';
import * as S from './RankIndicator.styles';

interface RankIndicatorProps {
  score: number;
  min: number;
  max: number;
}

export const RankIndicator: React.FC<RankIndicatorProps> = ({ score, min, max }) => {
  const normalizedScore = Math.max(0, Math.min(1, (score - min) / (max - min)));

  const getBarActiveState = (barIndex: number) => {
    const threshold = barIndex * 0.2;
    return normalizedScore >= threshold;
  };

  return (
    <S.Div>
      <S.Bar $height={20} $isActive={getBarActiveState(0)} />
      <S.Bar $height={40} $isActive={getBarActiveState(1)} />
      <S.Bar $height={60} $isActive={getBarActiveState(2)} />
      <S.Bar $height={80} $isActive={getBarActiveState(3)} />
      <S.Bar $height={100} $isActive={getBarActiveState(4)} />
      {/* <div className="score">{score}</div> */}
    </S.Div>
  );
};
